import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import styles from './UpdatePermissionsModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import LoadingButton from '../../../../Components/LoadingButton';
import PermissionsToggles from './PermissionsToggles';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const UpdatePermission = (props) => {
  const { userData, isTrial, availableSubscriptions } = props;
  const [isAdmin, setIsAdmin] = useState(userData.is_org_admin);
  const [isPro, setIsPro] = useState(userData.assigned_to_search);
  const handleUpdate = () => {
    if (isAdmin !== userData.is_org_admin) {
      props.toggleAdmin(userData.id);
    }
    if (isPro !== userData.assigned_to_search) {
      if (isPro) {
        props.assignToSearch(userData.id);
      } else {
        props.unassignToSearch(userData.id);
      }
    }
    if (isAdmin === userData.is_org_admin && isPro === userData.assigned_to_search) {
      props.clickedCloseModalButton();
    }
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Update user permissions')}</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <PermissionsToggles
        adminPermissionStatus={isAdmin}
        searchPermissionStatus={isPro}
        handleAdminToggle={() => setIsAdmin(!isAdmin)}
        handleSearchToggle={() => setIsPro(!isPro)}
        initialSearchStatus={props.userData.assigned_to_search}
        isTrial={isTrial}
        availableSeats={availableSubscriptions}
        isSelfUser={props.currentLoggedEmail === userData.email}
      />
      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.UPDATE_USER_PERMISSIONS}
            eventData={{
              manipulatedUser: userData.id,
              manipulatedUserEmail: userData.email,
              search: isPro,
              admin: isAdmin,
              previousPermissions: { search: userData.assigned_to_search, admin: userData.is_org_admin },
            }}
          >
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              id="submit-button"
              onClick={handleUpdate}
              text={gettext('Save')}
              width="39%"
              loadingText={gettext('Updating')}
              isLoading={props.permissionsLoading}
              disabled={isAdmin === userData.is_org_admin && isPro === userData.assigned_to_search}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            id="cancel-button"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            width="39%"
          />
        </div>
      </div>
    </div>
  );
};

UpdatePermission.propTypes = {
  userData: PropTypes.object,
  toggleAdmin: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
  permissionsLoading: PropTypes.bool,
  isTrial: PropTypes.bool,
  availableSubscriptions: PropTypes.number,
  assignToSearch: PropTypes.func,
  unassignToSearch: PropTypes.func,
  trialEndDate: PropTypes.string,
  currentLoggedEmail: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    permissionsLoading: UsersSelectors.isLoadingPermissionsSelector(state),
  };
};

const mapDispatchToProps = {
  toggleAdmin: UsersActions.adminHandle,
  assignToSearch: UsersActions.assignToSearch,
  unassignToSearch: UsersActions.unassignToSearch,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePermission);
